export enum RelayLocationEnum {
    onDevice = 0,
    canIo = 1,
}
